import * as Sentry from '@sentry/react';
import type {AxiosInstance} from 'axios';

import {throttle} from 'shared/helpers/throttle';
import {CompanyStatus} from 'shared/models/company';
import store from 'store';
import {profileActionTypes} from 'store/profile/profileActions';

class AccessControl {
  private static instance: AccessControl | null = null;
  private axiosInstance: AxiosInstance | null = null;

  public static getInstance(): AccessControl {
    if (!AccessControl.instance) {
      AccessControl.instance = new AccessControl();
    }
    return AccessControl.instance;
  }

  public setAxiosInstance(instance: AxiosInstance) {
    this.axiosInstance = instance;
  }

  public handleAccessDenied = throttle(async () => {
    if (!this.axiosInstance) {
      console.error('Axios instance not set in AccessControl');
      return;
    }

    const state = store.getState();
    const activeCompanyId = state.profile.activeCompanyId;

    if (!activeCompanyId) return;

    try {
      const response = await this.axiosInstance.get(`/companies/${activeCompanyId}`);
      if (response.data?.status === CompanyStatus.Disabled) {
        if (!state.profile.showAccessDeniedPopup) {
          store.dispatch(profileActionTypes.showAccessDeniedPopup(true));
        }
      }
    } catch (error) {
      Sentry.captureException(error, {
        tags: {
          errorType: 'AccessControl',
          message: 'Failed to fetch company status',
        },
      });
    }
  }, 1500);
}

export const accessControl = AccessControl.getInstance();
